import UnavailableSystemPage from './UnavailableSystemPage'
import ExpiredLinkPage from './ExpiredLinkPage'
import ResetPasswordPage from './ResetPasswordPage'
import FirstAccessPage from './FirstAccessPage'
import SAPConcurIntegrationPage from './SAPConcurIntegrationPage'
import DashboardPage from './DashboardPage'
import EmployeesPage from './EmployeesPage'
import UsersPage from './UsersPage'
import CompanyPage from './CompanyPage'
import CostCentersPage from './CostCentersPage'
import ProjectsPage from './ProjectsPage'
import UsagePoliciesPage from './UsagePoliciesPage'
import CreditPoliciesPage from './CreditPoliciesPage'
import ReportsPage from './ReportsPage'
import InvoiceHistoryPage from './InvoiceHistoryPage'
import FinancialAdjustmentsPage from './FinancialAdjustmentsPage'
import ManualRetrievalPage from './ManualRetrievalPage'
import ImportNfePage from './ImportNfePage'
import RevenuesPage from './RevenuesPage'
import SearchPhonePage from './SearchPhonePage'
import RequestTokenPage from './RequestTokenPage'
import WebCallPage from './WebCallPage'
import UsagePolicyPage from './UsagePolicyPage'
import WelcomePage from './WelcomePage'
import WizardPage from './WizardPage'
import EmployeePage from './EmployeePage'
import EmployeeMassCreditPolicyPage from './EmployeeMassCreditPolicyPage'
import BulkImportPage from './BulkImportPage'

export default {
  UnavailableSystemPage,
  ExpiredLinkPage,
  ResetPasswordPage,
  FirstAccessPage,
  SAPConcurIntegrationPage,
  DashboardPage,
  EmployeesPage,
  UsersPage,
  CompanyPage,
  CostCentersPage,
  ProjectsPage,
  UsagePoliciesPage,
  CreditPoliciesPage,
  ReportsPage,
  InvoiceHistoryPage,
  FinancialAdjustmentsPage,
  ManualRetrievalPage,
  ImportNfePage,
  RevenuesPage,
  SearchPhonePage,
  RequestTokenPage,
  WebCallPage,
  UsagePolicyPage,
  WelcomePage,
  WizardPage,
  EmployeePage,
  EmployeeMassCreditPolicyPage,
  BulkImportPage
}
